export enum EventStrings {
  // Page Titles
  SelectAnEvent = 'YEvZ',

  // Column Headers
  EventName = 'YdUX',
  Date = 'mcQK',
  Type = 'uq3f',

  // Messages
  NoAvailableEvent = 'ekft',
  NoOpenEventsToSelect = 'rPs8',
  NoEvent = 'wuZk',
}
